/*
    window.debugLog is an object meant to help us get LX up to 100% by
    supplying a convenient place to log data out to for easy debugging.

    The most crucial piece of information is the request marker, which can
    be used to help search in splunk.

    Special cases and errors will also be logged.  By looking
    at window.debugLog.log, you will find an array that represents the sequential
    order of events that we have deemed needed for logging.

    It is recommended that only a few endpoints will log here, like the api/logger.
    If you want to start logging here from another endpoint, add similar code:

    window && window.log ? window.log(data) : null; // eslint-disable-line
*/
function logError(event = {}) {
    let errorMessage = '';
    if (!!event.error && typeof event.error === 'object') {
        if (event.error.message) {
            errorMessage = event.error.message;
        }
    } else if (typeof event.error === 'string') {
        errorMessage = event.error;
    }

    this.debugLog.log.push(`[ERROR] ${errorMessage}`);
}

function setupDebugLog(context, systemReducer, requestState = {}) {
    // eslint-disable-line complexity
    let variant = 'MOBILE';
    if (systemReducer.isTablet) {
        variant = 'TABLET';
    } else if (systemReducer.isDesktop) {
        variant = 'DESKTOP';
    }
    // This function here might be getting called after the store has been hydrated,
    // which might have re-evaluated the device based on window width.
    // Fallback to that if the requestState isn't set.
    // Set the requestState's value to uppercase to match our current patterns.
    variant = requestState.deviceType ? requestState.deviceType.toUpperCase() : variant;

    context.debugLog = {
        requestMarker: systemReducer.requestMarker || 'NOTSET',
        site: systemReducer.siteName || 'NOTSET',
        variant,
        log: []
    };

    context.addEventListener('error', logError.bind(context));

    // Global function to add to the log.
    context.log = (data) => {
        context.debugLog.log.push(data);
    };
}

export default setupDebugLog;
export {setupDebugLog, logError};
